import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { Payment } from '../types';

export function usePaymentHistory(page = 1) {
  return useQuery({
    queryKey: ['payments-history', page],
    queryFn: async (): Promise<Payment[]> =>
      pb.send(`/api/payments/history?page=${page}`, { method: 'GET' }),
    staleTime: 60_000,
  });
}
